import { render, staticRenderFns } from "./TableOpenDeliveries.vue?vue&type=template&id=491b7ae0&scoped=true&"
import script from "./TableOpenDeliveries.vue?vue&type=script&lang=js&"
export * from "./TableOpenDeliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491b7ae0",
  null
  
)

export default component.exports